module.exports = __webpack_public_path__ + "static/faro-images-2-53a4304f1cd8f9bbbbe173b18ae9c9a8.jpg";